import { Model } from "@tailflow/laravel-orion/lib/model";

export class CatalogItem extends Model {
    $resource(): string {
        return "module/catalog-item";
    }
}
